import React from 'react'
import CV from './CV'
import './Header.css'
import Me from '../../assets/paul1.png'
import HeaderSocials from './HeaderSocials'


const Header = () => {
    return (

        <header>
            <div className='container header__container'>
                <h5>Hello, I am</h5>
                <h1><b>John Paul D. Salazar</b></h1>
                <h4 className="text-light"><b>IT TECHNICAL SUPPORT</b></h4>
                <CV />
                <HeaderSocials />
                <div className='me'>
                    <img src={Me} alt='John Paul D. Salazar' />
                </div>
                <a href="#footer" className='scroll__down'>Scroll Down</a>

            </div>
        </header>

    )
}

export default Header